import { render, staticRenderFns } from "./submitter_filter.vue?vue&type=template&id=6582a556&"
import script from "./submitter_filter.vue?vue&type=script&lang=js&"
export * from "./submitter_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports